module.exports = __webpack_public_path__ + "static/img/5-6.76587b0.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/6/5-6.png
// module id = 277
// module chunks = 0